module.exports = __webpack_public_path__ + "img/2.b25f1f77.jpg";